import { breakpoints } from 'styles/mq'
import { Section } from 'components/section'
import { Animation } from './animation'
import { ColoredTitle } from 'components/colored-title'
import DataWrapperChart from 'components/datawrapper'
import ContactInfo from 'components/contact-info'
import { Parallax } from 'components/parallax'

import Woman from './parallax/woman'
import Plate from './parallax/plate'
import Pot from './parallax/pot'
import { List, HeroImage, SectionWrapper, TwoColumns } from './styled'
import { Light } from 'styles/typography'
import { ChapterFooter } from 'components/layout/chapter-footer'
import { authors } from './footer-data'

import coloredTitleA_L from './images/ColoredTitle2A_L.webp'
import coloredTitleA_M from './images/ColoredTitle2A_M.webp'
import coloredTitleA_S from './images/ColoredTitle2A_S.webp'
import coloredTitleB_L from './images/ColoredTitle2B_L.webp'
import coloredTitleB_M from './images/ColoredTitle2B_M.webp'
import coloredTitleB_S from './images/ColoredTitle2B_S.webp'

import HeroSrc_L from './images/FullWidth_L.webp'
import HeroSrc_M from './images/FullWidth_M.webp'
import HeroSrc_S from './images/FullWidth_S.webp'

export const Kazakhstan = () => {
  return (
    <>
      <Animation />
      <Section containerType="text">
        <p>
          В Казахстане тема насилия в отношении женщин остается острой, несмотря
          на резонансные случаи и поправки к законодательству. Согласно{' '}
          <a
            href="https://library.fes.de/pdf-files/bueros/kasachstan/20141.pdf"
            target="_blank"
            rel="noreferrer"
          >
            исследованиям
          </a>
          , женщины в сельской местности особенно уязвимы – без должной
          инфраструктуры и в изоляции они рискуют остаться без поддержки в
          нужный момент.
        </p>
        <p>
          Зарина (имя изменено) оказалась именно в такой ситуации – после побоев
          со стороны мужа под нажимом полиции ей пришлось забрать заявление. Но
          она решила сбежать из дома. Уйти от насилия ее вдохновили другие
          женщины из интернет-форума, на котором она зарегистрировалась.
        </p>
        <p>
          Однако спустя пять лет после ухода Зарина простила насильника и
          вернулась к нему.
        </p>
        <p>
          <Light>
            Предупреждение: в материале присутствуют описания сцен насилия
          </Light>
        </p>
        <p>
          Этот материал – часть проекта{' '}
          <a
            href="https://voicesofthebrave.asia/"
            target="_blank"
            rel="noreferrer"
          >
            "Голоса смелых"
          </a>
          , посвященного гендерному насилию в Центральной Азии. Мы рассказываем
          истории женщин, переживших насилие, чтобы показать масштаб проблемы и
          дать голос тем, кто зачастую говорить не может.
        </p>
      </Section>

      <Parallax side="left">
        <Woman />
      </Parallax>

      <Section
        containerType="text"
        heading='"Я решила, что должна уйти от него"'
      >
        <p>
          В маленьком селе на севере Казахстана едва можно насчитать 50 домов.
          Только в одном из них в тот вечер горел свет, это был дом Зарины и ее
          супруга Ануара (имя изменено). Они спорили друг с другом: Зарина с
          грудным сыном на руках настойчиво требовала у супруга разжечь огонь в
          доме. Старшая дочь, первоклассница, уже слегка простудилась, женщина
          переживала и за младшего ребенка.
        </p>
        <p>
          Однако просьбы жены только раздражали Ануара. Он позвонил своей
          матери, проживающей в нескольких метрах от их дома, и попросил ее
          вмешаться: "Эта дура сама не может дом натопить", – раздраженно сказал
          он.
        </p>
        <p>
          Свекровь пришла быстро, и в доме начался хаос, вспоминает она. Зарина
          пыталась уворачиваться от нападок женщины, но те не прекращались.
          Удары, дергание за волосы, злобные оскорбления и угрозы лишить ее
          родительских прав сыпались как град. Одной рукой Зарина держала
          младенца, а другой оборонялась. Вдруг неожиданный удар от мужа –
          настолько сильный, что девушка потеряла равновесие и упала.
        </p>
        <p>
          "Вместо того чтобы защитить меня, он ударил и пнул. Так сильно, что я
          не могла встать, думала, ноги отказали. Тогда, стараясь улыбаться,
          чтобы не напугать детей, я решила, что должна уйти от него", –
          вспоминает Зарина.
        </p>
      </Section>
      <Section
        containerType="text"
        heading='"Ты должна сидеть дома и ждать меня с горячим чаем!"'
      >
        <p>
          Зарина была младшим ребенком в семье, поэтому ее берегли от тяжести
          домашних дел. В ее мире не было места заботам и лишнему контролю со
          стороны родителей. Она говорит, что выросла в городе, в атмосфере
          легкости и свободы.
        </p>
        <p>
          Окончив университет, в 23 года Зарина вышла замуж за одногруппника, в
          которого была влюблена. Она вспоминает, что для нее Ануар был
          воплощением уверенности и самостоятельности: сам купил дом, мог
          сделать все своими руками и казался хозяйственным. Зарина думала, что
          с ним она будет в безопасности.
        </p>
        <p>
          Ануару же в Зарине понравились ее приверженность семейным ценностям.
          Ее позиция "одна жизнь – один муж", привитая ей с детства, казалась
          ему очень правильной. С такой верной и преданной девушкой он хотел
          провести свою жизнь.
        </p>
        <p>
          Молодожены сыграли скромную свадьбу и сразу же переехали в маленькое
          село, расположенное в нескольких сотнях километров от города, где
          Ануару предложили работу.
        </p>
        <p>
          Поначалу Зарине нравилась сельская жизнь: просторные степи, закаты,
          запах свежескошенной травы, яркое звездное небо. Она говорит, что это
          казалось ей идиллическим и безмятежным.
        </p>
        <p>
          Но романтизация сельской жизни прошла, как только Зарина столкнулась с
          реальностью. Воду нужно было набирать в колодце и таскать в ведрах.
          Дрова приходилось рубить или искать сухие ветки у речки, чтобы
          отапливать дом. Пасти гусей, заниматься множеством других домашних
          обязанностей – все это было для нее незнакомым. Она не привыкла к
          такому тяжелому труду. К тому же у них родилась дочь, и вся ее энергия
          уходила на уход за ребенком.
        </p>
        <p>
          Соседки в селе не проявляли сочувствия – вместо этого вслед Зарине
          раздавались упреки: "Нехозяйственная!"
        </p>
        <p>
          "Весной я любила собирать подснежники. Но соседи все время
          насмехались: мол, зачем я трачу время на какую-то ерунду. Летом, когда
          я в красивом платье выходила гулять с дочкой, они начинали говорить,
          будто я себя всем показываю. Мужу это не нравилось. Он агрессивно
          требовал "не выпендриваться". Я не понимала, что же я делаю не так.
          Почему все эти люди вокруг такие злые и недовольные?" – рассказывает
          Зарина.
        </p>
        <p>
          Однажды Зарина вернулась домой с прогулки и увидела на полу разбитый
          заварочный чайник. Ее сердце екнуло. На вопрос, почему он это сделал,
          Ануар злобно сказал: "Не свежезаваренный чай, так не положено! Ты
          должна сидеть дома и ждать меня с горячим чаем. Это твоя обязанность!"
        </p>
        <p>
          Отношения с мужем становились все хуже, ссора за ссорой – девушка не
          помнит, когда он впервые ее ударил. В какой-то момент насилие стало
          частью ее жизни. Окружение считало это нормой: в их селе каждый
          мужчина мог ударить жену.
        </p>
        <p>
          Она говорит, что Ануар наслаждался ее беспомощностью и издевался над
          ней – отключал газовый баллон, чтобы она не могла готовить, а затем,
          как будто этого было недостаточно, выкручивал пробки в электрическом
          щите, лишая ее электричества.
        </p>
        <p>Так жизнь Зарины становилась серой, лишенной тепла и света.</p>
      </Section>
      <Section containerType="text" heading="Переезд и новая работа">
        <p>
          Когда старшей дочке исполнилось четыре года, Зарина забила тревогу.
          Девочка так и не заговорила. Медработники в селе не придавали этому
          значения – все считали, что "само пройдет". Но Зарина все же решила
          показать дочь городским специалистам. Результаты обследования
          подтвердили ее опасения – у девочки был синдром, вызванный нехваткой
          общения. Из-за того, что с ней мало разговаривали, она не могла
          воспроизводить звуки, которые не слышит, а общения с мамой ей было
          недостаточно.
        </p>
        <p>
          Зарина понимала, что для развития речи ребенку нужно больше социальных
          контактов, и попросила мужа переехать в более крупное село, где было
          больше детей, с которыми дочь могла бы играть и общаться. Ануар
          согласился, и они втроем перебрались в его родное село, где жили его
          родители.
        </p>
        <p>
          Зарина надеялась, что на новом месте ей и самой будет легче:
          родственники мужа помогут и поддержат. Но все оказалось наоборот.
          Свекровь, живущая по соседству, восприняла невестку как "новую рабочую
          силу". Муж стал проводить все время на работе, но денег семье все
          равно не хватало.
        </p>
        <p>
          Чтобы заработать самой, Зарина устроилась работать в местную школу,
          где требовались специалисты с высшим образованием. Вскоре ее повысили
          до руководящей должности. Тогда их положение существенно улучшилось.
        </p>
        <p>
          С каждым днем у нее становилось все больше дел, совещаний и рабочих
          поездок по району. За несколько лет работы она добилась уважения как
          профессионал и как человек, к которому всегда можно прийти за советом.
        </p>
        <p>
          "Я почувствовала себя настоящей личностью. Востребованной! Мне этого
          так не хватало", – вспоминает Зарина.
        </p>
        <p>Но ее карьеру прервал второй декрет.</p>
      </Section>

      <Parallax side="right">
        <Plate />
      </Parallax>

      <Section
        containerType="text"
        heading='"Я тут подумал: сделай аборт. Ребенок не мой"'
      >
        <p>
          Зарину поздравляла вся семья, кроме свекрови. Та не разделяла радости,
          а напротив, была крайне недовольна новостью. Начала тщательно
          высчитывать даты зачатия и стала утверждать, что в тот день Зарина
          была в рабочей поездке, а значит, ребенок не мог быть Ануара. Спустя
          несколько месяцев настойчивых разговоров и сомнений, Ануар тоже начал
          верить в эту ложь.
        </p>
        <p>
          "Однажды он пришел с работы и сказал: "Я тут подумал: сделай аборт.
          Ребенок не мой". В тот момент все, что я представляла себе о семье,
          рухнуло. Я была так огорчена", – вспоминает Зарина.
        </p>
        <p>
          Зарина решила, что хочет оставить ребенка, даже если будет воспитывать
          его одна. Ануар хоть и неохотно, но принял ее решение. Она родила
          сына, но желанным он был только для Зарины.
        </p>
        <p>
          "Муж не хотел с ним возиться. Постоянно говорил: "Там твой плачет, иди
          успокой его". Так сильно он поверил в ложь своей матери", – вспоминает
          Зарина.
        </p>
        <p>
          Ануар не помогал жене с работой по дому, а ссоры все чаще
          заканчивались побоями. Тогда Зарина начала искать помощи в интернете:
          читала статьи, подписывалась на женские форумы. Однажды ей попалась
          страничка известной психологини. Там она впервые узнала о таких вещах,
          как "абьюз" и "личные границы".
        </p>
      </Section>

      <ColoredTitle src={[coloredTitleA_S, coloredTitleA_M, coloredTitleA_L]} />

      <Section containerType="text">
        <p>
          "Сначала я ничего не поняла, даже удивилась, что это за границы
          такие", – вспоминает Зарина. Но чем больше информации она узнавала,
          тем яснее становилось, что она находится в абьюзивных отношениях.
          После того как девушка поделилась своей историей о насилии, с ней на
          форуме связались специалисты и посоветовали фиксировать побои, чтобы в
          случае повторения у нее были доказательства.
        </p>
      </Section>
      <Section
        containerType="text"
        heading='"Эта ложь была ценой моего спасения"'
      >
        <p>
          Однажды вечером муж и свекровь избили Зарину. После этого они оставили
          ее лежать на холодном полу. Зарина вспоминает, что ее ноги онемели,
          она долго не могла встать из-за сильной боли. Еле дотянувшись до
          телефона, она вызвала врача. Двигаться не получалось. Врач приехала
          быстро, сделала обезболивающий укол и посоветовала подать заявление на
          мужа не в сельскую полицию, где личные связи имеют влияние, а в
          городскую – чтобы дело точно не закрыли.
        </p>
        <p>
          Собрав все фотографии со следами побоев, Зарина поехала в город
          зафиксировать синяки и ссадины. Она прошла обследование в травмпункте
          и подала заявление в полицию. К ее удивлению, заявление приняли быстро
          и даже отправили бригаду в село для расследования.
        </p>
        <p>
          В Казахстане существуют специальные подразделения по защите женщин от
          насилия. Их сотрудники посещают семейных агрессоров, помогают
          пострадавшим от насилия – поддерживают психологически и объясняют, как
          действовать по закону. Хотя число таких сотрудников за последние годы
          растет, речь идет о 256 специалистах на 20-миллионный Казахстан.
        </p>
      </Section>
      <TwoColumns>
        <DataWrapperChart
          nomargin={true}
          title="В Казахстане растет число специалистов, защищающих женщин от насилия"
          ariaLabel="Interactive line chart"
          id="datawrapper-chart-cDTlC"
          src="https://datawrapper.dwcdn.net/cDTlC/4/"
          height="513px"
        />
        <DataWrapperChart
          nomargin={true}
          title="Всего в Казахстане действуют 44 кризисных центра"
          ariaLabel="Map"
          id="datawrapper-chart-Ef3IV"
          src="https://datawrapper.dwcdn.net/Ef3IV/4/"
          height="529px"
        />
      </TwoColumns>
      <Section containerType="text">
        <p>
          Специалисты могут самостоятельно выносить защитные предписания и
          направлять пострадавших в кризисные центры.
        </p>
        <p>
          В то же время Зарина связалась с юристкой, которая консультировала ее
          на женском форуме. По телефону она рассказала о ее правах и
          настоятельно посоветовала срочно собрать вещи и детей, забрать все
          документы и уезжать.
        </p>
        <p>
          Девушка решила ехать к родителям, которые жили за границей. Добраться
          до них не было проблемой, так как она уже не раз путешествовала с
          детьми. Однако для выезда за границу нужны были документы. Уйдя в
          декрет, она все еще числилась как сотрудница местной школы, и ее
          диплом, а также документы дочери находились в администрации школы.
        </p>
        <p>
          В школе Зарине не отдали документы – "не положено" было единственным
          аргументом. Более того, ей посоветовали сначала наладить отношения с
          мужем, а потом уже решать все остальные вопросы.
        </p>
        <p>
          Чтобы забрать документы из школы, ей пришлось отозвать заявление из
          полиции. В отделении полиции ей вручили листок, ручку и потребовали
          написать объяснительную.
        </p>
        <p>
          "Я писала такую чушь под диктовку полицейских, что сама не могла в это
          поверить. Якобы я выдумала побои, чтобы попасть в травмпункт без
          очереди, а на самом деле – я просто упала со стремянки в кусты, когда
          белила дом, и поэтому по всему лицу появились царапины. А спиной я
          ударилась о лестничную перекладину. Я писала не в силах сдерживать
          слезы, но понимала: чтобы уехать, мне нужно соврать. Эта ложь была
          ценой моего спасения", – говорит Зарина.
        </p>
        <p>
          После того как она отозвала заявление из полиции, документы из школы
          ей сразу же вернули. Зарина заявила мужу, что больше не намерена с ним
          жить, купила билеты в один конец и села в поезд с детьми.
        </p>
        <p>
          "Я решилась на этот шаг только благодаря женщинам с форума. Они
          показали мне, насколько неправильно со мной обращались, и научили
          важным вещам о личных границах, женской силе и безопасности. Они
          подсказали, что нужно делать, когда нет выхода, и как не потерять
          себя. Я никогда не встречала этих женщин в реальной жизни, но в тот
          момент они стали моими спасительницами. Их поддержка дала мне силы и
          план действий в ситуации насилия", – делится Зарина.
        </p>
      </Section>
      <div>
        <picture>
          <source srcSet={HeroSrc_S} media={breakpoints.smallOnly} />
          <source srcSet={HeroSrc_M} media={breakpoints.ltLarge} />
          <HeroImage src={HeroSrc_L} />
        </picture>
        <SectionWrapper>
          <Section containerType="text" heading="Раскаяние и второй шанс">
            <p>
              Зарина с детьми переехала за границу в дом к родителям. Несколько
              месяцев она приходила в себя после произошедшего. Через полгода
              после отъезда в доме ее родителей появился Ануар.
            </p>
            <p>
              Он приехал извиниться за совершенное им и его матерью насилие.
              Зарина говорит, что для нее это был "самый важный поступок от
              него". Однако не стала прощать его сразу – по ее словам, в тот
              момент она не была готова строить с ним отношения.
            </p>
            <p>
              Зарине потребовалось пять лет. Это время стало для нее
              терапевтическим: она училась заново жить и определять свои личные
              границы. С каждым днем она становилась увереннее в себе,
              пересматривала приоритеты. То, что раньше казалось ей нормой, с
              новым опытом и знаниями стало неприемлемым.
            </p>
            <p>
              Все это время Ануар регулярно приезжал навестить детей и в
              очередной раз извиниться. Кроме того, он стал замечать, что
              младший сын становился все больше похожим на него.
            </p>
            <p>
              Так он понял, что многое в жизни упустил, и начал искать пути, как
              все исправить. В следующую свою поездку он попросил Зарину
              вернуться к нему вместе с детьми.
            </p>
            <p>
              Но в сознании Зарины не осталось места иллюзиям – для нее
              возвращение в село не было даже вариантом. Она понимала, что
              счастливая жизнь может быть только вдали от родственников мужа. Но
              семью сохранить хотела.
            </p>
            <p>
              Она поставила Ануару условие: если он хочет начать все заново, им
              нужно переехать в город, в более развитую среду, где у детей и у
              нее самой будет шанс для роста и возможности. А еще Зарина
              выдвинула требования к их будущим отношениям: ей был нужен
              партнер, который учитывал бы ее потребности и уважал границы.
              Ануар выслушал ее и согласился со всеми условиями.
            </p>
            <p>
              Зарина вернулась в Казахстан, но уже с новыми взглядами и желанием
              создавать здоровые отношения, основанные на взаимном уважении и
              поддержке. Спустя некоторое время она родила третьего ребенка.
            </p>
          </Section>

          <ColoredTitle
            src={[coloredTitleB_S, coloredTitleB_M, coloredTitleB_L]}
          />

          <Section containerType="text">
            <p>
              Аида Альжанова, экспертка по вопросам гендерного равенства
              объясняет, что реальные и устойчивые перемены возможны только в
              редких случаях, когда агрессор осознает проблему, проходит
              длительную терапию и работает над изменением своего поведения. По
              ее словам, даже психологическая помощь не всегда помогает, если в
              сообществе, где живет насильник, домашнее насилие нормализовано и
              не считается уголовным преступлением.
            </p>
            <p>
              "Существует цикличность, приводящая к тому, что многие
              пострадавшие возвращаются к насильнику, веря в его изменения.
              Однако в большинстве случаев насилие со временем возобновляется, а
              его интенсивность может даже увеличиваться по спирали", –
              объясняет Аида Альжанова.
            </p>
            <p>
              Цикл насилия – это повторяющийся паттерн, характерный для
              абьюзивных отношений. По словам Альжановой, он обычно включает три
              основные фазы:
              <List>
                <li>
                  Фаза нарастания{' '}
                  <span>
                    – агрессор становится раздражительным, контролирующим,
                    оказывает эмоциональное или психологическое давление.
                  </span>
                </li>
                <li>
                  Фаза острого насилия{' '}
                  <span>
                    – происходит физическое, эмоциональное или
                    сексуализированное насилие.
                  </span>
                </li>
                <li>
                  Фаза примирения ("медовый месяц"){' '}
                  <span>
                    – агрессор раскаивается, обещает измениться, проявляет
                    заботу, создавая иллюзию перемен.
                  </span>
                </li>
              </List>
            </p>
          </Section>
          <Section containerType="text" heading="Протянуть руку другим">
            <p>
              История Зарины – редкое исключение. Чаще всего цикл насилия
              повторяется: и пострадавшие, доверившись абьюзеру, возвращаются,
              но сталкиваются с насилием вновь.
            </p>
            <p>
              Зарина с Ануаром и детьми уже больше пяти лет живут вместе.
              Девушка говорит, что муж изменился и поддерживает ее во всем.
            </p>
            <p>
              "Я чувствую себя намного лучше, чем в те времена, когда молча
              терпела то, что мне не нравилось. Вот уже несколько лет мы
              действительно счастливы. Он услышал меня, а я – его", –
              рассказывает Зарина.
            </p>
            <p>
              Со свекровью она так и не общается с момента их последнего
              конфликта.
            </p>
            <p>
              Дети посещают развивающие кружки, а Зарина активно занимается
              саморазвитием. Более того, она помогает другим женщинам, которые,
              как и она когда-то, пережили насилие. Это жительницы того самого
              села, из которого Зарина несколько лет назад сбежала. Ситуация там
              почти не изменилась: женщин все еще бьют мужья, а свекрови
              продолжают оказывать психологическое давление. Но теперь у них
              есть пример – Зарина. Она доказала, что уходить можно и нужно.
            </p>

            <Parallax side="left">
              <Pot />
            </Parallax>

            <p>
              "Одна моя знакомая, увидев мой пример, тоже решилась уйти от мужа.
              Недавно мы встретились, и она сказала, что я помогла ей понять:
              молчать нельзя, домашнее насилие это ненормально", – делится
              Зарина.
            </p>
            <p>
              Зарина хоть и тихо, но старается помогать всем, кому может.
              Благодаря ее поддержке, уже несколько женщин смогли выйти из
              абьюзивных отношений, рассказывает она. Сейчас она помогает своим
              знакомым уйти от насильников: отвечает на вопросы девушек, делится
              опытом и дает конкретные рекомендации.
            </p>
            <p>
              Зарина верит, что даже небольшая поддержка может изменить жизнь, и
              мечтает о том, чтобы женщины в ее окружении перестали бояться
              говорить о своих проблемах. Она уверена, что каждая из них
              заслуживает жить без страха и с надеждой на лучшее будущее.
            </p>
            <p>
              "В сельской местности Казахстана и Центральной Азии насилие в
              отношении женщин происходит из-за глубоко укоренившихся
              патриархальных традиций и вольной интерпретации религиозных
              канонов в пользу мужчин, в которой признается вторичная роль
              женщин, приемлемость многоженства и даже возможность телесного
              наказания", – говорит Аида Альжанова.
            </p>
            <p>
              По ее словам, чтобы бороться с гендерным насилием в сельской
              местности, необходимы конкретные меры: доступная помощь
              пострадавшим, строгая ответственность для насильников,
              экономическая поддержка женщин и информационные кампании против
              насилия. Важно также вовлекать женщин в политику, обучать
              специалистов работе с пострадавшими, бороться с языком ненависти и
              собирать данные, чтобы принимать эффективные меры.
            </p>
          </Section>
          <ContactInfo />
        </SectionWrapper>
      </div>
      <ChapterFooter authors={authors} />
    </>
  )
}
